import { ComponentColors } from '@/enums'
import { useAnimateEffect } from '@/utils'
import { Dispatch, ReactNode, SetStateAction } from 'react'
import { Typography } from '../Typography'
import { Container } from './styles'

interface SnackbarProps {
  color?: keyof typeof ComponentColors
  duration?: number
  children: ReactNode | string
  onClose: Dispatch<SetStateAction<string | undefined>>
}

export const Snackbar = ({
  color,
  children,
  duration = 5000,
  onClose,
}: SnackbarProps) => {
  const { isOpen, leaving } = useAnimateEffect({
    onLeave: onClose,
    duration,
    defaultOpened: Boolean(children),
  })

  if (!isOpen) return null

  return (
    <Container color={color} leaving={leaving}>
      <Typography variant="p1Body">{children}</Typography>
    </Container>
  )
}
